import { FIELD_NAMES } from 'utils/constants';

function fromGQL(obj) {
  const { value, ...returnableField } = obj;
  return {
    ...returnableField,
    name: FIELD_NAMES.CP_DEGREE_OFFERING,
    editors: {
      degreeOfferingConfig: {
        programId: value.programId,
        degreeOffering: value.degreeOffering,
      },
    },
  };
}

function toGQL({ editors: { degreeOfferingConfig } }) {
  return {
    value: { ...degreeOfferingConfig },
    name: FIELD_NAMES.DEGREE_OFFERING,
  };
}

export default {
  fromGQL,
  toGQL,
};
